import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React from 'react';
import { Typography } from '@mui/material';

/**
 * A section heading. It must read as a level above the field labels, which use
 * `text.secondary` at weight 500, so it takes `text.primary` and a rule to show its span.
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
export function SectionTitle({ children }) {
  return (
    <Typography
      variant="h6"
      sx={{
        color: 'text.primary',
        fontSize: '1.125rem',
        fontWeight: 700,
        borderBottom: 1,
        borderColor: 'divider',
        pb: 0.5,
      }}
    >
      {children}
    </Typography>
  );
}

/**
 * @param {Object} props
 * @param {Object|number} props.size
 * @param {Object|string} [props.title=null]
 * @param {React.ReactNode} [props.children=null]
 * @param {Object|string} [props.titleIcon=null]
 * @param {string} [props.iconJustification='space-between']
 */
export function GridWrapper({
  size,
  title = null,
  children = null,
  titleIcon = null,
  iconJustification = 'space-between',
}) {
  return (
    <Grid size={size}>
      <Grid container spacing={1} sx={{ justifyContent: iconJustification, alignItems: 'center' }}>
        {/* Stretched so the rule spans the section, except where the icon sits beside it. */}
        <Grid sx={{ flexGrow: iconJustification === 'space-between' ? 1 : 0 }}>
          {title && <SectionTitle>{title}</SectionTitle>}
        </Grid>
        <Grid size="fit-to-content">
          {titleIcon}
        </Grid>
        <Grid size={12}>
          { children }
        </Grid>
      </Grid>
    </Grid>
  );
}

/**
 * @param {Object} props
 * @param {React.ReactNode} [props.children=null]
 * @param {string} [props.className='']
 * @param {number} [props.size=12]
 */
export function BoxWrapper({
  children = null,
  className = '',
  size = 12,
}) {
  return (
    <Box
      sx={{
        padding: '10px',
        backgroundColor: 'subtleBackground',
        borderRadius: '.25rem',
      }}
      className={className}
      // Hook for cypress/e2e/rendered-tokens.cy.js, which asserts this panel paints the token.
      data-surface="subtle"
    >
      <Grid container size={size} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {children}
      </Grid>
    </Box>
  );
}
